import styles from "../../styles/Blog/VerticalBlog.module.css";
import "../../styles/Blog/Blogs.css";
import { useNavigate } from "react-router-dom";
import formatDate from "../../Utils/FormatDate";
import { base_url } from "../../ReuableFunctions/Blogs";

const VerticalBlog = ({ data }) => {
  const navigate = useNavigate();

  function handleRedirect(blogId){
    console.log("Rediecting to the blog", blogId);
    navigate(`/blog/${blogId}`)
    window.scrollTo(0,0)
  }
  return (
    <div className={styles.blogContainer} onClick={()=>handleRedirect(data?.["blogId"])} style={{cursor:"pointer"}}>
      <div className={styles.blogInnerContainer}>
        <div className={styles.blogImage}>
          <img src={`${base_url}/blog-image/${data?.["blogId"]}`} className={styles.Image} alt="blog-image" loading="lazy" />
        </div>
        <div className={styles.blogTagsContainer}>
          {data?.blogCategory?.split(",").map((tag, index) => (
            <span key={index} className={styles.blogTag}>
              {tag}
            </span>
          ))}
        </div>
        <div className={styles.blogTitle}>
          {data?.blogTitle ?? "Title Not Available"}
        </div>
        <div className={styles.blogInfoContainer}>
          <div className={styles.blogInfoImageAndNameContainer}>
            <div className={styles.blogInfoImage}></div>
            <div className={styles.blogInfoName}>Mohit Valecha</div>
          </div>
          <div className={styles.blogRightDate}>
            <img src="/calendar.svg" alt="calendar" loading="lazy" />
            <span>{formatDate(data?.["createdDate"])}</span>
          </div>
          {/* <div className={styles.blogRightRead}>
            <img src="/time.svg" alt="calendar" />
            <span>3 min read</span>
          </div> */}
        </div>
        <div className={styles.blogRightDesc}>
          {data?.blogDescription ?? "Description Not Available"}
        </div>
      </div>
    </div>
  );
};

export default VerticalBlog;
